import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";


// LOGIN
export const AdminLogout = async (role) =>
  commonFetch(`${API_URLS.ADMIN_LOGOUT_APIURL}?roleName=${role}`, {
    method: "POST",
    requiresAuth: true,
  });

export const StudentLogout = async (role) =>
  commonFetch(`${API_URLS.STUDENT_LOGOUT_APIURL}?roleName=${role}`, {
    method: "POST",
    requiresAuth: true,
  });

export const EmployeeLogout = async (role) =>
  commonFetch(`${API_URLS.EMPLOYEE_LOGOUT_APIURL}?roleName=${role}`, {
    method: "POST",
    requiresAuth: true,
  });

export const ParentLogout = async (role) =>
  commonFetch(`${API_URLS.PARENT_LOGOUT_APIURL}?roleName=${role}`, {
    method: "POST",
    requiresAuth: true,
  });
